import { useMemo } from 'react'
import CustomTable from '../../components/base/table'
import Box from "@mui/material/Box"
import { useGet } from '../../utils/hooks'
import { format } from "date-fns"
import useAuthStore from "../../store/auth"

const COLUMNS = [
  {
    field: 'date',
    headerName: 'Data',
    align: 'left',
    width: 180,
    sortable: true,
    valueGetter: val => format(val, 'dd/MM/yyyy')
  },
  {
    field: 'user',
    headerName: 'Usuário',
    align: 'left',
    width: 180,
    sortable: true,
  }
]

const DayOffPage = () => {
  const { data, error, isLoading } = useGet('miss')
  const user = useAuthStore(state => state.user)

  const rows = useMemo(() => {
    if (error || isLoading) return []
    if (!data) return []
    return data.map(entry => {
      return {
        id: entry.id,
        user: entry.User.name,
        date: new Date(entry.date),
      }
    })
  }, [error, isLoading, data])

  return (
    <Box sx={{ flex: 1 }}>
      <CustomTable
        rows={rows}
        loading={isLoading}
        columns={COLUMNS}
        label='Faltas'
        initialState={{
          sorting: {
            sortModel: [{ field: 'date', sort: 'asc' }],
          },
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
          columns: {
            columnVisibilityModel: {
              user: user.isAdmin
            },
          },
        }}
      />
    </Box>
  )
}

export default DayOffPage